import SectionHeading from '@/components/base/SectionHeading';
import Reveal from '@/components/base/Reveal';

const steps = [
  {
    icon: 'ri-message-3-line',
    title: '先找源头，不急着转发',
    desc: '看到一条爆料，先问它最早出现在哪。很多瓜在转发到第三手时，语气已经被放大了好几倍。',
    tone: 'primary',
  },
  {
    icon: 'ri-time-line',
    title: '把碎片放进时间线',
    desc: '单张截图说明不了什么，但把它放到时间线上，就能看出哪句话在前、哪句话在后，顺序一变意思就全变了。',
    tone: 'accent',
  },
  {
    icon: 'ri-links-line',
    title: '交叉验证至少两个来源',
    desc: '同一个说法如果只来自一个匿名账号，就先记下「存疑」。能对上媒体、行程或当事人回应，可信度才会上升。',
    tone: 'secondary',
  },
  {
    icon: 'ri-emotion-happy-line',
    title: '该收手时就收手',
    desc: '真相没出来之前，别去打扰当事人和素人。追线索是为了看得更清楚，不是为了把谁逼到墙角。',
    tone: 'primary',
  },
];

const wrapTone: Record<string, string> = {
  primary: 'bg-primary-100 text-primary-700',
  accent: 'bg-accent-100 text-accent-800',
  secondary: 'bg-secondary-100 text-secondary-800',
};

export default function GuideSection() {
  return (
    <section id="guide" className="bg-background-50 py-16 md:py-20">
      <div className="mx-auto w-full px-4 md:px-6">
        <SectionHeading
          kicker="吃瓜方法论"
          title="四步走，把一场瓜看明白"
          desc="热闹是别人的，判断力得是自己的。这套流程我们每天都在用，也欢迎你拿去用。"
          align="center"
        />

        <div className="mt-10 grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-4">
          {steps.map((step, index) => (
            <Reveal key={step.title} delay={index * 80}>
              <article className="flex h-full flex-col rounded-lg border border-background-200 bg-background-100 p-6">
                <span className={`flex h-12 w-12 items-center justify-center rounded-md ${wrapTone[step.tone]}`}>
                  <i className={`${step.icon} text-2xl`} />
                </span>
                <h3 className="mt-5 font-heading text-lg font-bold text-foreground-950">
                  <span className="mr-2 text-sm text-primary-600">第 {index + 1} 步</span>
                  <span className="mt-1 block">{step.title}</span>
                </h3>
                <p className="mt-3 text-sm leading-relaxed text-foreground-600">{step.desc}</p>
              </article>
            </Reveal>
          ))}
        </div>

        <Reveal delay={120}>
          <div className="mt-8 flex flex-col items-start gap-4 rounded-lg bg-secondary-100 p-6 sm:flex-row sm:items-center sm:justify-between">
            <p className="flex items-start gap-3 text-sm leading-relaxed text-secondary-900">
              <i className="ri-lightbulb-flash-line mt-0.5 text-lg" />
              <span>
                记住一句话：<strong className="font-bold">「能证明存在，不等于能证明为真」</strong>。截图只能证明有人说过这句话，不能证明这句话本身是对的。
              </span>
            </p>
          </div>
        </Reveal>
      </div>
    </section>
  );
}